module.exports = __webpack_public_path__ + "img/v-blue.044ac5f1.svg";